// extracted by mini-css-extract-plugin
module.exports = {"circle":"circle__Q-CKn","completed":"completed__QvlOu","has-notification":"has-notification__m68oG","in-progress":"in-progress__5qTDY","not-started":"not-started__y02+v"};